export default "__VITE_ASSET__7875ae4d__"